import { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill-new';
import useRenderGenerateBtn from '../../../hooks/render-generate-btn.hook';
import AIToolbar from '../ai-toolbar';
import './ai-react-quill.styles.scss';
import 'react-quill-new/dist/quill.snow.css';

/**
 * AIReactQuill component
 * @param {*} [props] 
 * @param {boolean} [props.isLoading]
 * @param {function} [props.onButtonClick]
 * @param {function} [props.onUpdate]
 * @param {boolean} [props.passConfig]
 * @param {any} [props.modules]
 * @param {any} [props.formats]
 * @param {string} [props.bounds]
 * @param {string} [props.placeholder]
 * @param {any} [props.value]
 * @param {function} [props.onChange]
 * 
 * @returns 
 */
const AIReactQuill = ({ isLoading, onButtonClick, onUpdate, passConfig = true, ...props }) => {
  const inputRef = useRef(null);
  const { parentRef: coverNoteRef, generateInReactQuill } = useRenderGenerateBtn();

  useEffect(() => {
    if (!coverNoteRef?.current || !onButtonClick) return;
    generateInReactQuill({
      loading: isLoading,
      onButtonClick: onButtonClick
    });
  }, [
    coverNoteRef, onButtonClick, isLoading
  ]);

  useEffect(() => {
    if (!inputRef?.current) return;
    onUpdate(inputRef?.current?.value);
  }, [inputRef]);

  return (
    <div ref={coverNoteRef} className="cliet-report-cover-note covernote position-relative ai-react-quill">
      <ReactQuill
        {...props}
        ref={inputRef}
      />
      <div className={`ai-toolbar-wrapper ${props?.isShowOnHover && 'hover-on-show-child'}`}>
        <AIToolbar inputRef={inputRef} passConfig={passConfig} />
      </div>
    </div>
  )
}

export default AIReactQuill;
